/** Composes global motion preferences, theme, and portfolio state around the application. */
import { MotionConfig } from 'framer-motion';
import type { ReactNode } from 'react';
import { AdminAuthProvider } from '../../features/admin/presentation/context/AdminAuthContext';
import { PortfolioProvider } from '../../features/portfolio/presentation/context/PortfolioContext';
import { ThemeProvider } from '../../features/theme/presentation/context/ThemeContext';

export function AppProviders({ children }: { readonly children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user" transition={{ ease: [0.16, 1, 0.3, 1] }}>
      <ThemeProvider>
        <AdminAuthProvider>
          <PortfolioProvider>{children}</PortfolioProvider>
        </AdminAuthProvider>
      </ThemeProvider>
    </MotionConfig>
  );
}
